// Vendor
import * as React from 'react';

// Vendor Components
import {ChildProps} from 'react-apollo';
import {Redirect, RouteProps} from 'react-router';
import {compose} from 'recompose';

// Shared Components
import asyncComponent from 'isee/ui/components/async-component';
import CenteredSpinner from 'isee/ui/components/centered-spinner/centered-spinner';

// Async Components
const Admin = asyncComponent(() => import('isee/ui/admin'));
const Client = asyncComponent(() => import('isee/ui/client'));
const Professional = asyncComponent(() => import('isee/ui/professional'));

// Components
import withRedux, {SessionTokenProps} from './components/with-redux';
import withSignOut, {SignOutFunc} from './components/with-sign-out';
import withViewer, {Kind, ViewerResult} from './components/with-viewer';

// Services
import ApolloService from 'isee/services/apollo/apollo';

// Types
interface Props extends RouteProps {}

interface WithSignOutProps {
  signOut: SignOutFunc;
}

type EnhancedProps = Props &
  WithSignOutProps &
  SessionTokenProps &
  ChildProps<{}, ViewerResult>;

interface State {
  isSigninOut: boolean;
}

const enhance = compose<EnhancedProps, Props>(
  withViewer,
  withRedux,
  withSignOut
);

export class Authenticated extends React.Component<EnhancedProps, State> {
  public readonly state: Readonly<State> = {
    isSigninOut: false
  };

  public componentDidMount() {
    this.resetTokenIfNoViewer();
  }

  public componentDidUpdate() {
    this.resetTokenIfNoViewer();
  }

  public render() {
    const {isSigninOut} = this.state;
    const {location, data} = this.props;
    const {loading, viewer} = data!;

    if (loading && !viewer) {
      return <CenteredSpinner padding={50} />;
    }

    if (!viewer || !viewer.kind) {
      const state = {from: isSigninOut ? '/' : location};
      return <Redirect to={{pathname: '/sign-in', state}} />;
    }

    const {kind} = viewer;

    switch (kind) {
      case Kind.Admin:
        return <Admin signOut={this.handleSignOut} viewer={viewer} />;
      case Kind.Client:
        return <Client signOut={this.handleSignOut} viewer={viewer} />;
      case Kind.Professional:
        return <Professional signOut={this.handleSignOut} viewer={viewer} />;
    }
  }

  private cleanupSession() {
    const {resetToken} = this.props;
    resetToken();
    ApolloService.client.resetStore();
  }

  private resetTokenIfNoViewer() {
    const {loading, viewer} = this.props.data!;
    if (!loading && !viewer) this.cleanupSession();
  }

  private handleSignOut = async () => {
    this.setState({isSigninOut: true});
    try {
      await this.props.signOut();
    } catch (e) {
    } finally {
      this.cleanupSession();
    }
  };
}

export default enhance(Authenticated);



// WEBPACK FOOTER //
// ./src/ui/authenticated/authenticated.tsx